import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import './SectionNav.css';

export const SectionNav = ({ items, label = 'On this page', className = '' }) => {
  const { pathname, hash } = useLocation();
  const [active, setActive] = useState(items[0]?.id);
  const navigation = useRef(null);

  useEffect(() => {
    let frame;
    const nav = navigation.current;
    const page = nav?.closest('.page-section');
    const update = () => {
      const headerBottom = document.querySelector('.site-navbar')?.getBoundingClientRect().bottom || 0;
      const nav = navigation.current;
      const horizontal = nav && getComputedStyle(nav).position === 'sticky' && getComputedStyle(nav).flexDirection === 'row';
      const readingLine = Math.max(headerBottom, horizontal ? nav.getBoundingClientRect().bottom : 0) + 48;
      let current = items[0]?.id;
      for (const item of items) {
        const section = document.getElementById(item.id);
        if (section && section.getBoundingClientRect().top <= readingLine) current = item.id;
      }
      setActive(current);
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    const measure = () => {
      const height = nav?.getBoundingClientRect().height;
      if (height) page?.style.setProperty('--section-nav-height', `${Math.ceil(height)}px`);
      schedule();
    };
    measure();
    const observer = window.ResizeObserver ? new window.ResizeObserver(measure) : null;
    if (nav) observer?.observe(nav);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', measure);
    return () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', measure);
      page?.style.removeProperty('--section-nav-height');
    };
  }, [items, pathname, hash]);

  return (
    <nav ref={navigation} className={`section-nav ${className}`} aria-label={label}>
      <p>On this page</p>
      {items.map(item => (
        <HashLink key={item.id} to={`#${item.id}`} aria-current={active === item.id ? 'location' : undefined} onClick={() => setActive(item.id)}>
          <span className="section-nav-label">{item.title}</span>
          <span className="section-nav-arrow" aria-hidden="true">↓</span>
        </HashLink>
      ))}
    </nav>
  );
};
